import { render } from "./Task_budgets.vue?vue&type=template&id=7f66663a&scoped=true"
import script from "./Task_budgets.vue?vue&type=script&lang=js"
export * from "./Task_budgets.vue?vue&type=script&lang=js"

import "./Task_budgets.vue?vue&type=style&index=0&id=7f66663a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f66663a"]])

export default __exports__